import { useContext, useEffect, useState } from "react";
import * as Styled from "./styled";
import { Eye, Pencil, Trash2 } from "lucide-react";
import { ServicesContext } from "../../context/ContextServices/context";
import { deleteServices, loadServices } from "../../context/ContextServices/actions";
import { useNavigate } from "react-router-dom";

const Services = () => {

  const navigate = useNavigate();
  const services = useContext(ServicesContext);
  const { state, dispatch } = services;

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const formatDate = (date: any) => {
    if (!date) return "";

    if (date.toDate) {
      return date.toDate().toLocaleDateString("pt-BR", {
        timeZone: "UTC"
      });
    }

    return new Date(date).toLocaleDateString("pt-BR", {
      timeZone: "UTC"
    });
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm("Tem certeza que deseja excluir este serviço?")) return;
    await deleteServices(dispatch, id);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    loadServices(dispatch);
  }, [dispatch]);

  const filteredServices = state.services.filter((serv: any) => {

    const matchSearch =
      serv.modeloMoto?.toLowerCase().includes(search.toLowerCase()) ||
      serv.placa?.toLowerCase().includes(search.toLowerCase()) ||
      serv.tipoConserto?.toLowerCase().includes(search.toLowerCase()) ||
      serv.nomeCliente?.toLowerCase().includes(search.toLowerCase());

    const matchStatus =
      statusFilter === "" || serv.status === statusFilter;

    return matchSearch && matchStatus;

  });

  return (
    <Styled.Container>
      <Styled.Content>

        <h1>Lista de Serviços</h1>

        <Styled.SearchContainer>

          <Styled.SearchInput
            type="text"
            placeholder="Pesquisar serviços..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Styled.SelectInput
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="Em Andamento">Em Andamento</option>
            <option value="Concluído">Concluído</option>
          </Styled.SelectInput>

        </Styled.SearchContainer>

        <Styled.ContentService>

          <Styled.ContentServiceHeader>
            <span>CLIENTE</span>
            <span>MODELO</span>
            <span>PLACA</span>
            <span>TIPO</span>
            <span>ENTRADA</span>
            <span>SAÍDA</span>
            <span>STATUS</span>
            <span>AÇÕES</span>
          </Styled.ContentServiceHeader>

          {filteredServices.map((serv: any) => (

            <Styled.ContentServiceContent key={serv.id}>
              <Styled.Cliente>{serv.nomeCliente}</Styled.Cliente>

              <Styled.Modelo>{serv.modeloMoto}</Styled.Modelo>

              <Styled.Placa>{serv.placa}</Styled.Placa>

              <Styled.Tipo>{serv.tipoConserto}</Styled.Tipo>

              <Styled.Entrada>
                {formatDate(serv.dataEntrada)}
              </Styled.Entrada>

              <Styled.Saida>
                {formatDate(serv.dataSaida)}
              </Styled.Saida>

              <Styled.Status status={serv.status}>
                {serv.status}
              </Styled.Status>

              <Styled.Acoes>

                <Eye size={18} color="#3371FC" onClick={() => navigate(`/dashboard/servico/${serv.id}`)} />

                <Pencil
                  size={18}
                  onClick={() =>
                    navigate("/dashboard/novo-servico", { state: { service: serv } })
                  }
                />

                <Trash2
                  size={18}
                  color="#E7000B"
                  onClick={() => handleDelete(serv.id)}
                />

              </Styled.Acoes>

            </Styled.ContentServiceContent>

          ))}

        </Styled.ContentService>

      </Styled.Content>
    </Styled.Container>
  );
};

export default Services;